import syncFields from '../_syncfields.js';
import apply from '../../_helpers/apply.js';
import reportModified from '../_reportmodified.js';
import assign from '../../_helpers/assign.js';
import itemsNotIn from '../_diffitems.js';
import { checkCompatRenderer } from '../_processrendering/checkbeforechange.js';
import toArray from '../../_helpers/toarray.js';
export default function createCopyWithin(hasOptions) {
  return function copyWithin() {
    syncFields(this);
    // +hasOptions is converted to 0 or 1 depending on its value (false/true)
    var argsLength = Math.max(arguments.length - +hasOptions, 0);
    var args = Array(argsLength);
    var givenEventOptions = hasOptions ? arguments[arguments.length - 1] : null;
    for (var i = 0; i < argsLength; i++) {
      args[i] = arguments[i];
    }
    checkCompatRenderer(this, 'copyWithin', givenEventOptions);
    var was = toArray(this);
    apply(Array.prototype.copyWithin, this, args);
    // an overwritten item the array no longer holds is removed, so its listeners come off
    var eventOptions = {
      method: 'copyWithin',
      self: this,
      added: [],
      removed: itemsNotIn(was, this)
    };
    // extend event options by custom event options if they are given
    if (hasOptions) {
      if (givenEventOptions && typeof givenEventOptions === 'object') {
        assign(eventOptions, givenEventOptions);
      }
    }
    reportModified(this, eventOptions);
    return this;
  };
}